import { WindowOrderStatus } from '@cutr/constants/windows/windows';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type PaginationState = {
  pageIndex: number;
  pageSize: number;
};

export type DateFilters = {
  createdBefore: string;
  createdAfter: string;
  submittedBefore: string;
  submittedAfter: string;
};

export type FiltersState = {
  pagination: PaginationState;
  search: string;
  statuses: WindowOrderStatus[];
  dateFilters: DateFilters;
};

const DEFAULT_FILTERS_STATE: FiltersState = {
  pagination: {
    pageIndex: 0,
    pageSize: 30,
  },
  search: '',
  statuses: ['draft', 'quote_requested', 'quote_ready', 'change_requested'],
  dateFilters: {
    createdBefore: '',
    createdAfter: '',
    submittedBefore: '',
    submittedAfter: '',
  },
};

type FiltersStateActions = {
  setPagination(pagination: PaginationState): void;
  setSearch(search: string): void;
  setStatuses(statuses: WindowOrderStatus[]): void;
  setDateFilters(dateFilters: DateFilters): void;
  resetFilters(): void;
};

export const useWorkspaceFilterStore = create<
  FiltersState & FiltersStateActions
>()(
  persist(
    (set) => ({
      ...DEFAULT_FILTERS_STATE,
      setPagination: (pagination) => set(() => ({ pagination })),
      setSearch: (search) => set(() => ({ search })),
      setStatuses: (statuses) => set(() => ({ statuses })),
      setDateFilters: (dateFilters) => set(() => ({ dateFilters })),
      resetFilters: () => set(() => ({ ...DEFAULT_FILTERS_STATE })),
    }),
    {
      name: 'window-workspace-filters',
    }
  )
);
